import React, { useState, useEffect, useCallback, useMemo, useContext } from "react";
import { ProductContext } from "../../../stores/session";
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";

export default function useWorkflow({ spid, setSpid, setData, setPurchasable, selectedWholesaler, selectedAdcGroup, selectedDate, selectedStatus }) {
    const { apiPrefix, isWorkflow } = useContext(ProductContext)
    const [loading, setLoading] = useState(false);
    const [workflowItems, setWorkflowItems] = useState([]);

    const _cur = useMemo(() => {
        return workflowItems.findIndex(_ => _ === spid);
    }, [workflowItems, spid]);

    const getWorkflowNext = () => {
        if (_cur !== workflowItems.length - 1) {
            setSpid(workflowItems[_cur + 1]);
        }
    }

    const getWorkflowLast = () => {
        if (_cur !== 0) {
            setSpid(workflowItems[_cur - 1]);
        }
    }

    useEffect(() => {
        if (isWorkflow) {
            getWorkflowItems()
        }
    }, [selectedWholesaler, selectedAdcGroup, selectedDate, selectedStatus])

    const getWorkflowItems = useCallback(() => {
        setLoading(true)
        request(true).get(endpoints[`${apiPrefix}_WF_ITEMS`], {
            doesCancel: true,
            params: {
                selectedWholesaler: selectedWholesaler,
                selectedDate: selectedDate,
                selectedAdcGroup: selectedAdcGroup,
                status: selectedStatus
            }
        }).then(r => {
            setWorkflowItems(r.data);
            const currentSpid = r.data[_cur && _cur !== -1 ? _cur : 0]
            const prevSpid = r.data[_cur - 1]
            setSpid(currentSpid ?? prevSpid ?? r.data[0])
            if (!r.data[0]) {
                setData({})
                setPurchasable(false);
            }
            setLoading(false);
        }).catch(e => {
            console.log(e);
            window.alert('Could not retrieve data');
            setLoading(false);
        });
    }, [_cur, selectedWholesaler, selectedAdcGroup, selectedDate, selectedStatus])

    return { getWorkflowItems, workflowItems, loading, getWorkflowLast, getWorkflowNext, _cur }
}